export default "__VITE_ASSET__32ac9e60__"